export default "__VITE_ASSET__BrN2Jjlg__"